module.exports = __webpack_public_path__ + "img/help_red.25e0eb8c.png";